import AboutEstimator from './AboutEstimator'
import Awards from './Awards'
import Cover from './Cover'
import Custom from './Custom'
import Divider from './Divider'
import Documents from './Documents'
import Image from './Image'
import SliderImage from './SliderImage'
import Introduction from './Introduction'
import Gallery from './Gallery'
import Mission from './Mission'
import Pictures from './Pictures'
import Quote from './Quote'
import Services from './Services'
import Terms from './Terms'
import Testimonials from './Testimonials'
import Text from './Text'
import TwoColumn from './TwoColumn'
import ThreeColumn from './ThreeColumn'
import WorkOrder from './WorkOrder'
import Socials from './Socials'

// Sherwin Williams
import ColorHelp from './partners/SherwinWilliams/ColorHelp'
import ColorSamples from './partners/SherwinWilliams/ColorSamples'
import PopularColors from './partners/SherwinWilliams/PopularColors'
import ColorOfTheYear from './partners/SherwinWilliams/ColorOfTheYear'
import TopColors from './partners/SherwinWilliams/TopColors'
import FinestWhitesNeutrals from './partners/SherwinWilliams/FinestWhitesNeutrals'
import ExpertCollections from './partners/SherwinWilliams/ExpertCollections'
import ExploreExterior from './partners/SherwinWilliams/ExploreExterior'
import ChipsToDoor from './partners/SherwinWilliams/ChipsToDoor'
import HottestColors from './partners/SherwinWilliams/HottestColors'
import FinestWhites from './partners/SherwinWilliams/FinestWhites'
import PeelNStick from './partners/SherwinWilliams/PeelNStick'
import MatchAPhoto from './partners/SherwinWilliams/MatchAPhoto'
import ScheduleConsultation from './partners/SherwinWilliams/ScheduleConsultation'
import UploadPhotos from './partners/SherwinWilliams/UploadPhotos'
import ColorVisualizer from './partners/SherwinWilliams/ColorVisualizer'
import ColorExpert from './partners/SherwinWilliams/ColorExpert'
import SampleColors from './partners/SherwinWilliams/SampleColors'
import DesignerColorCollection from './partners/SherwinWilliams/DesignerColorCollection'
import ColormixForecast from './partners/SherwinWilliams/ColormixForecast'

// Benjamin Moore
import MainPage from './partners/BenjaminMore/MainPage'

export default {
  'about-estimator': AboutEstimator,
  awards: Awards,
  cover: Cover,
  custom: Custom,
  divider: Divider,
  documents: Documents,
  image: Image,
  sliderImage: SliderImage,
  introduction: Introduction,
  gallery: Gallery,
  mission: Mission,
  pictures: Pictures,
  quote: Quote,
  services: Services,
  terms: Terms,
  testimonials: Testimonials,
  text: Text,
  socials: Socials,
  '2-column': TwoColumn,
  '3-column': ThreeColumn,
  'work-order': WorkOrder,
  'sherwin-williams-popular-colors': PopularColors,
  'sherwin-williams-color-of-the-year': ColorOfTheYear,
  'sherwin-williams-top-colors': TopColors,
  'sherwin-williams-finest-whites-neutrals': FinestWhitesNeutrals,
  'sherwin-williams-expert-collections': ExpertCollections,
  'sherwin-williams-explore-exterior': ExploreExterior,
  'sherwin-williams-color-samples': ColorSamples,
  'sherwin-williams-chips-to-door': ChipsToDoor,
  'sherwin-williams-hottest-colors': HottestColors,
  'sherwin-williams-finest-whites': FinestWhites,
  'sherwin-williams-peel-n-stick': PeelNStick,
  'sherwin-williams-color-help': ColorHelp,
  'sherwin-williams-upload-photo': UploadPhotos,
  'sherwin-williams-schedule-consultation': ScheduleConsultation,
  'sherwin-williams-match-a-photo': MatchAPhoto,
  'sherwin-williams-paint-color-visualizer': ColorVisualizer,
  'sherwin-williams-color-expert': ColorExpert,
  'sherwin-williams-sample-colors': SampleColors,
  'sherwin-williams-designer-color-collection': DesignerColorCollection,
  'sherwin-williams-colormix-forecast': ColormixForecast,
  'benjamin-moore-main': MainPage
}
